import { CloudOff } from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";

const ConnexionErrorDiv = () => {
  return (
    <Box bgcolor="#eee" flex={5} p={1} sx={{ marginLeft: "40px" }}>
      <div
        style={{
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 5,
        }}
      >
        <CloudOff sx={{ color: "", fontSize: "4rem" }} />
        <h2>Connexion Impossible</h2>
        <span>
          <b>https://etpm.chiksoft.com</b>, a mis trop du temps à répondre
        </span>
        <span> Vérifiez votre connexion internet et réessayer</span>
      </div>
    </Box>
  );
};

export default ConnexionErrorDiv;
